import { useScrollIntoView } from '@/hooks/useScrollIntoView';

interface ErrorNoticeProps {
  message: string | string[];
  details?: string[];
}

export const ErrorNotice = ({ message, details }: ErrorNoticeProps) => {
  const ref = useScrollIntoView<HTMLDivElement>();

  // messageを配列に正規化
  const messages = Array.isArray(message) ? message : [message];
  // detailsがある場合は結合
  const allMessages = details && details.length > 0
    ? [...messages, ...details]
    : messages;

  return (
    <div className="common-error mx-2" role="alert" ref={ref}>
      {allMessages.length === 1 ? (
        allMessages[0]
      ) : (
        <ul className="mb-0 pl-4">
          {allMessages.map((msg, index) => (
            <li key={index}>{msg}</li>
          ))}
        </ul>
      )}
    </div>
  );
};
